export function FeaturesSection() {
  const features = [
    {
      icon: 'ri-wifi-off-line',
      color: 'green',
      title: 'Mode Hors Ligne',
      desc: 'Continuez à utiliser l\'app même sans internet.',
      highlight: 'Synchronisation automatique dès la reconnexion.',
    },
    {
      icon: 'ri-smartphone-line',
      color: 'orange',
      title: 'Mobile Money',
      desc: 'Paiements via Orange Money, MTN, Moov et solutions locales.',
      highlight: 'Zéro commission pour les clients.',
    },
    {
      icon: 'ri-global-line',
      color: 'blue',
      title: 'Multilingue',
      desc: 'Français, anglais, swahili, wolof, arabe et portugais.',
      highlight: 'Adaptation culturelle de l\'interface.',
    },
    {
      icon: 'ri-shield-keyhole-line',
      color: 'red',
      title: 'Sécurité Avancée',
      desc: 'Authentification OTP, chiffrement des données.',
      highlight: 'Traçabilité des transactions.',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-sm font-semibold text-teal-600 uppercase tracking-wider mb-2">
            Technologie
          </p>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Conçu pour l'Afrique</h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            Des technologies adaptées aux réalités du continent
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map(f => (
            <div key={f.title}
              className={`bg-white p-7 rounded-2xl shadow-sm border border-${f.color}-100
                hover:shadow-lg transition-all duration-200 group`}>
              <div className={`w-16 h-16 bg-${f.color}-600 rounded-2xl flex items-center justify-center mb-5
                group-hover:scale-105 transition-transform`}>
                <i className={`${f.icon} text-white text-3xl`} />
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">{f.title}</h4>
              <p className="text-gray-500 text-sm mb-2 leading-relaxed">{f.desc}</p>
              <p className={`text-${f.color}-600 text-sm font-semibold`}>{f.highlight}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturesSection;
